const SITE_HOSTNAME = 'blog.seeds-9.com';

document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('a[href]');

  links.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      return;
    }

    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
    // the current host counts as internal too, so local previews (127.0.0.1) behave like production
    if (url.hostname === SITE_HOSTNAME || url.hostname === window.location.hostname) return;

    if (!link.hasAttribute('target')) {
      link.setAttribute('target', '_blank');
    }

    const rel = link.getAttribute('rel');
    if (!rel || !rel.includes('noopener')) {
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});
